import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { ChangePassword } from "@/components/ChangePassword";

export const AccountPanel = () => {
  const { user, refresh, signOut } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState(user?.name || "");
  const [confirm, setConfirm] = useState("");
  const save = async () => {
    try {
      await api.put("/auth/me", { name });
      await refresh();
      toast.success("Profile updated");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const deactivate = async () => {
    try {
      await api.post("/auth/deactivate", { confirm });
      nav("/");
      signOut();
      toast.success("Account deactivated");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="grid gap-6 md:grid-cols-2" data-testid="account-panel">
      <div className="card-surface p-6 space-y-3">
        <h3 className="font-semibold text-lg">Profile</h3>
        <p className="text-sm text-slate-500" data-testid="account-email">{user?.email}</p>
        <Input value={name} onChange={(e) => setName(e.target.value)} data-testid="account-name-input" />
        <Button className="rounded-full" onClick={save} disabled={name.trim().length < 2} data-testid="account-save-btn">Save</Button>
      </div>
      <div className="card-surface p-6 space-y-3 border-rose-200">
        <h3 className="font-semibold text-lg text-rose-700">Deactivate account</h3>
        <p className="text-sm text-slate-600">Your active bookings will be cancelled and you will not be able to sign in. Type DEACTIVATE to confirm.</p>
        <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="DEACTIVATE" data-testid="deactivate-confirm-input" />
        <Button variant="destructive" className="rounded-full" disabled={confirm !== "DEACTIVATE"} onClick={deactivate} data-testid="deactivate-account-btn">Deactivate</Button>
      </div>
      <ChangePassword />
    </div>
  );
};
